import proxyResponseIframe from "./proxy-response-iframe";
import proxyResponseJson from "./proxy-response-json";
import proxyResponseWindow from "./proxy-response-window";
import proxyResponseDownload from "./proxy-response-download";
import proxyResponseDefault from "./proxy-response-default";
import proxyResponseViewer from "./proxy-response-viewer";
import proxyResponseOperationResult from "./proxy-response-operation-result";

export default angular.module("vesl.components.proxy-response-viewers", [
	proxyResponseIframe,
	proxyResponseJson,
	proxyResponseWindow,
	proxyResponseDownload,
	proxyResponseDefault,
	proxyResponseViewer,
	proxyResponseOperationResult
]).name;
